import { IconButton, Tooltip } from "@mui/material";
import { t } from "i18next";
import FileUtils from "../../utils/fileUtils";
import alertService from "../alert/alertService";
import { MAX_UPLOAD_FILE_SIZE } from "../../constants/form";
import ActivitiesService from "../../service/activities.service";
import { VisuallyHiddenInput } from "../../pages/emission/_components/data-table/EmissionDataTableStyle";

type Props = {
  filename: string;
  id: string;
  quickUploadFile: (base64: string) => void;
  disabled?: boolean;
  attachmentRef?: string;
};

export const QuickUploadFile = ({
  filename,
  id,
  disabled,
  attachmentRef,
  quickUploadFile,
}: Props) => {
  const uploadFile = async (event: any) => {
    const file: File[] = event.currentTarget.files;

    if (file[0]) {
      if (file[0].size > MAX_UPLOAD_FILE_SIZE) {
        alertService.info(
          t("Maximum-file-size-exceeded", {
            size: (MAX_UPLOAD_FILE_SIZE / 1e6).toFixed(0),
          }),
        );

        event.target.value = "";
      } else {
        //v1
        FileUtils.getBase64(file[0])
          .then(async (res) => quickUploadFile(res as string))
          .catch((err) => {
            event.target.value = "";
            alertService.error(t("Invalid-File-Type"));
          });
        // const presignedUrls = await EvidenceService.createPresignedUrls({
        //   evidenceFileName: file[0].name,
        //   suborganizationRef: suborganizationRef,
        //   year: year,
        // });

        // if (presignedUrls) {
        //   const result = await EvidenceService.uploadEvidenceToPresignedUrl(
        //     file[0],
        //     presignedUrls.evidenceS3UrlUpload
        //   );

        //   if (result) {
        //     alertService.mixin(t("Upload-Evidence-Success"));

        //     // updateData(presignedUrls);
        //   }
      }
    }
  };

  const previewAttachment = async () => {
    try {
      //// v1
      // const file = await ActivitiesService.getActivityAttachment(
      //   id
      // );

      // if (file) {

      //   window.open(
      //     URL.createObjectURL(FileUtils.base64ToFile(file.attachment))
      //   );
      // }

      const file = await ActivitiesService.getAttachment(attachmentRef!);

      if (file) {
        window.open(file.evidenceS3Url);
      }
    } catch (error) {
      alertService.info(t("Cannot-Preview-File"));
    }
  };

  return (
    <>
      {attachmentRef ? (
        <Tooltip title={filename} arrow>
          <IconButton
            component="label"
            key={id + "-icon-file-saved"}
            onClick={previewAttachment}
          >
            <img src="/img/icon-file-saved.svg" alt="icon-file" />
          </IconButton>
        </Tooltip>
      ) : (
        <IconButton component="label" key={id + "-icon-file-unsave"}>
          <img src="/img/icon-file-unsave.svg" alt="icon-file" />
          <VisuallyHiddenInput
            type="file"
            accept="image/*,application/pdf,.csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            key={id + "-visually-hidden-input"}
            name={id + "-visually-hidden-input"}
            onChange={uploadFile}
            disabled={disabled}
          />
        </IconButton>
      )}
    </>
  );
};
